module.exports = __webpack_public_path__ + "static/media/error_white.2e60a80e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/error_white.svg
// module id = 1071
// module chunks = 36